<template>
	<div>
		<v-container>
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" class="pa-2">
					<v-data-table
						hide-default-footer
						:headers="headers"
						:items="specialities"
						class="elevation-1"
						:loading="loading"
						:items-per-page="-1"
					>
						<template #top>
							<v-toolbar flat>
								<v-toolbar-title class="px-4">جدول الفئات المستهدفة - الدورات التدريبية</v-toolbar-title>
								<v-divider insert vertical></v-divider>
								<v-btn class="my-auto" height="100%" color="primary" text tile :to="{ name: 'dashboard-specialties' }">
									الفئات المستهدفة في المنصة
									<template v-if="allSpecialities.length">
										{{ allSpecialities.length }}
									</template>
									<template v-else>
										...
									</template>
									<v-icon right>
										mdi-account-group
									</v-icon>
								</v-btn>
								<v-divider insert vertical></v-divider>
								<v-spacer></v-spacer>
								<v-btn class="primary" @click="showAddNew = true">إظهار فئة مستهدفة جديدة</v-btn>
							</v-toolbar>
						</template>

						<template #[`item.delete`]="{ item }">
							<v-tooltip bottom>
								<template #activator="{ on }">
									<v-btn
										icon
										medium
										:disabled="loading"
										v-on="on"
										@click="deleteSpeciality(item.specialtiesID)"
									>
										<v-icon color="error">mdi-account-multiple-remove</v-icon>
									</v-btn>
								</template>
								<span>إخفاء</span>
							</v-tooltip>
						</template>
					</v-data-table>
				</v-col>
			</v-row>
		</v-container>

		<v-dialog v-model="showAddNew" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>إظهار فئة مستهدفة جديدة</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid">
						<v-row dense>
							<v-col cols="12" class="py-0">
								<v-select
									v-model="newSpeciality"
									:items="newSpecialities"
									item-text="name"
									outlined
									label="اسم الفئة"
									:rules="[rules.required]"
									return-object
								>
									<template #item="{ item }">
										<v-list-item-content>
											<v-list-item-title>
												{{ item.name }}
											</v-list-item-title>
											<v-list-item-subtitle v-if="item.femName" class="text-caption">
												{{ item.femName }}
											</v-list-item-subtitle>
										</v-list-item-content>
									</template>
								</v-select>
							</v-col>

							<v-col cols="12" class="text-center" @mouseover=";">
								<v-btn color="primary" :disabled="!valid" :loading="loading" @click="addNewSpeciality">إظهار</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";

export default {
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{ text: 'لوحة التحكم', to: { name: "dashboard-home" } },
				{ text: 'الدوات التدريبية', exact: true, to: { name: "dashboard-courses" } },
				{ text: 'الفئات المستهدفة', disabled: true }
			],
			specialities: [],
			allSpecialities: [],
			loading: true,
			headers: [
				{ value: "specialtiesID", text: "المعرف" },
				{ value: "name", text: "اسم الفئة" },
				{ value: "femName", text: "اسم الفئة المؤنثة" },
				{ value: "delete", text: "إخفاء" }
			],
			showAddNew: false,
			newSpeciality: null,
			valid: false
		};
	},
	computed: {
		newSpecialities() {
			var unselectedSpecialities = this.allSpecialities.filter(spec => {
				var index = this.specialities.findIndex(spec2 => {
					return spec.id == spec2.specialtiesID;
				});
				return index == -1;
			});

			// return unselectedSpecialities;
			return unselectedSpecialities.filter(spec => spec.userID == null);
		}
	},
	mounted() {
		this.getSpecialities();
		this.getAllSpecialities();
	},
	methods: {
		getSpecialities() {
			client
				.get("/api/courses/specialtiesList")
				.then(response => {
					this.loading = false;
					this.specialities = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		deleteSpeciality(id) {
			this.loading = true;

			client
				.delete("/api/courses/deleteSpecialtiesFromList/" + id)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");

					var index = this.specialities.findIndex(spec => {
						return spec.specialtiesID == id;
					});

					if (index != -1) {
						this.specialities.splice(index, 1);
					}

				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getAllSpecialities() {
			client
				.get("/api/specialties/all")
				.then(response => {
					this.allSpecialities = response.data;
					console.log(this.allSpecialities)
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		addNewSpeciality() {
			this.loading = true;

			var sp = this.newSpeciality.id;
			client
				.post("/api/courses/addSpecialtiesToList/" + sp)
				.then(response => {
					console.log(response);

					this.showAddNew = false;
					this.specialities.push({
						specialtiesID: this.newSpeciality.id,
						name: this.newSpeciality.name
					});
					this.newSpeciality = null
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>